import Icon from 'vue-awesome/components/Icon'

Icon.register({
  restore_page_rounded: {
    paths: [
      {
        d: 'M19.41 7.41l-4.83-4.83c-.37-.37-.88-.58-1.41-.58H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.42zM12 18c-1.65 0-3.19-.81-4.12-2.17a.75.75 0 01.19-1.04c.34-.24.81-.15 1.04.19.65.95 1.73 1.52 2.88 1.52 1.93 0 3.5-1.57 3.5-3.5a3.495 3.495 0 00-6.6-1.61L10.5 13H7c-.28 0-.5-.22-.5-.5V9l1.3 1.3A4.98 4.98 0 0112 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z'
      }
    ],
    width: '24',
    height: '24'
  }
})
